import Container from '../../components/Container';
import PageHeader from '../../components/PageHeader';
import PageSeo from '../../components/PageSeo';
import CensusData from './CensusData';

export default function CensusPage() {
  return (
    <div>
      <PageSeo title={`Shitty Census`} description='View statistics about the Shitty population.' />
      <PageHeader heading='Shitty Census' description='View statistics about the Shitty population.' />

      <Container fullWidth>
        <CensusData />
      </Container>
    </div>
  );
}
